import { InvoicesApiInstance, InvoicesApiPreviewInvoiceIdRequest } from '@melio/platform-api-axios-client';

export const getInvoicePreviewPDF = async (req: InvoicesApiPreviewInvoiceIdRequest): Promise<string> => {
  const response = await InvoicesApiInstance.previewInvoiceId(req);
  return response.data;
};
